export const DOT_HORIZONTAL_MARGIN = 0.7;
export const DOT_WIDTH = 0.25;
export const LINE_HEIGHT = 1.35;
export const HALF_LINE_HEIGHT = LINE_HEIGHT / 2;
